import React, { useContext, useEffect, useState } from 'react';
import { Badge, Button, Container, Form, Image } from "react-bootstrap"
import { Link, useNavigate } from "react-router-dom"
import FavoriteIcon from "../FavoriteIcon"
import * as Icon from 'react-bootstrap-icons';
import ApiFetch from "../ApiFetch";
import FollowButton from '../FollowButton';
import UserInfoPopup from './UserInfoPopup';
import { useTranslation } from "react-i18next";
import { LanguageCtx, LoginInfo } from '../../App';
import ImageViewPopup from '../ImageViewPopup';
import { rankingBgColor,rankingOpacity } from "./RankingUtil";
import UserMark from '../UserMark';
import VideoViewPopup from '../VideoViewPopup';
import TextViewPopup from '../TextViewPopup';
import EventViewPopup from '../EventViewPopup';
import { imgPath } from '../../service/CommonUtil';
import { LinkContainer } from 'react-router-bootstrap';
import { Chip } from '@mui/material';
import CharacterViewPopup from '../CharacterViewPopup';
import FavoriteIconMui from '@mui/icons-material/Favorite';
import StarIcon from '@mui/icons-material/Star';

const Tile = (props) => {
    async function getUserInfo(userIdOrDisplayId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateAgeLimitByAdmin(userId,ageLimit){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/ageLimit/"+userId,{ageLimit:ageLimit})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ナビゲート
    const navigate = useNavigate()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    let data = props.data
    let i = props.i
    let dialog = props.dialog
    let observer = props.observer
    let type = props.type || "image"
    let from = props.from || ""
    let rank = props.rank
    useEffect(() => {
        if(observer !== undefined){
            let lazys = document.querySelectorAll("."+(from === "popup" ? "lazy-popup" : "lazy"))
            let elm = lazys[lazys.length - 1]
            if(elm && elm.dataset.lazy !== "1"){
                observer.observe(elm)
                elm.dataset.lazy = "1"
            }
            document.querySelectorAll("."+(from === "popup" ? "lazy-popup" : "lazy")).forEach(e => {
                if(e.dataset.lazy !== "1"){
                    observer.observe(e)
                    e.dataset.lazy = "1"
                }
            })
        }
    })
    const [displayId,setDisplayId] = useState()
    const [selfIntroduction,setSelfIntroduction] = useState()
    const [follow,setFollow] = useState()
    const [follower,setFollower] = useState()
    const [isFollow,setIsFollow] = useState()
    const [ageLimit,setAgeLimit] = useState("allAges")
    const [showViewPopup,setShowViewPopup] = useState(false)
    const random = Math.random() * 100000
    function clearAllInterval(){
        for (var i = 1; i < 99999; i++)
            window.clearInterval(i)
    }
    const [title,setTitle] = useState("")
    // 言語設定
    const {language,setLanguage} = useContext(LanguageCtx)
    useEffect(() => {
        if(language === "ja"){
            setTitle(data.title)
        } else if(language === "en"){
            if(data.title_en && data.title_en.length > 0){
                setTitle(data.title_en)
            } else {
                setTitle(data.title)
            }
        }
    },[language,data])
    return (
<div style={{position:"relative",width:"100%"}} className={"event-card mb-0 p-0" + (!(data.age_limit === 1) ? " not-all-ages " : " ") + (data.mute === 1 ? " mute" : "")}
    onMouseOver={() => {
        let elm = document.querySelectorAll("."+from+"thumb-"+i).forEach(elm => {
            elm.style.opacity = "1"
            elm.style.transition = "0.1s"
        })
        document.querySelectorAll("."+from+"tile-img-"+i).forEach(elm => {
            elm.style.scale = "1.1"
            elm.style.transition = "0.3s"
        })
        setInterval(() => {
            if(type === "video" && data.status >= 4){
                document.querySelector("."+from+"tile-img-"+i).src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.VIDEO_HOST + imgPath(type) + '/post/t/'+(data.group_id)+"_digest"+ApiFetch.API_THUMB_EXT
                clearAllInterval()
            }
        },500)
    }}
    onMouseLeave={() => {
        let elm = document.querySelectorAll("."+from+"thumb-"+i).forEach(elm => {
            elm.style.opacity = "0"
            elm.style.transition = "0.1s"
        })
        document.querySelectorAll("."+from+"tile-img-"+i).forEach(elm => {
            elm.style.scale = "1"
            elm.style.transition = "0.3s"
        })
        if(type === "video" && data.status >= 4){
            document.querySelector("."+from+"tile-img-"+i).src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.VIDEO_HOST + imgPath(type) + '/post/t/'+(data.group_id)+"_m"+ApiFetch.API_THUMB_EXT
            clearAllInterval()
        }
    }}
>
    {type === "character" && showViewPopup ? <CharacterViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
    {type === "image" && showViewPopup ? <ImageViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
    {type === "video" && showViewPopup ? <VideoViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
    {type === "text" && showViewPopup ? <TextViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
    {type === "event" && showViewPopup ? <EventViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
	<div className="cp_ribbon05" style={{display:rank !== undefined ? "block" : "none"}}>
		<div className="cp_ribbon">TOP 3</div>
	</div>
    <div style={{position:"relative",padding:0,overflow:"hidden"}}
    onClick={(e) => {
        if(props.init){
            props.init()
        }
        if(props.isLink){
            navigate("/"+type+"/"+data.group_id)
            return
        }
        if(props.onClick === undefined){
            setShowViewPopup(true)
        } else {
            props.onClick()
        }
    }}
    >
        {rank === undefined && data.character_list !== undefined && data.character_list.length > 0 ? (<div style={{position:"absolute",top:"28px",right:"10px",zIndex:2}}>
            {data.character_list.filter(d => d.user_id === data.user_id).length === data.character_list.length ? <Chip label={<>公式</>} style={{fontSize:"14px",backgroundColor:"pink"}} size='small' /> :
            <Chip label={<><FavoriteIconMui style={{color:"red"}} /> ファンアート</>} style={{fontSize:"14px",backgroundColor:"pink"}} size='small' />}
        </div>) : ""}
        <div style={{position:"absolute",top:"8px",left:"10px",zIndex:2,display:props.shienLabelDisp !== false && data.limit_div !== undefined && data.limit_div !== "public" ? "block" : "none"}}>
            <Chip color="warning" label="支援者限定" style={{fontSize:"14px"}} size='small' />
        </div>
        <Badge bg="secondary" style={{position:"absolute",bottom:"8px",left:"50px",zIndex:2,display:data.find_prompt !== undefined && data.find_prompt === 1 ? "block" : "none"}}>
            <Icon.PSquareFill />
        </Badge>
        <Badge bg="secondary" style={{position:"absolute",zIndex:2,top:"8px",right:"10px",display:data.age_limit === 2 ? "block":"none"}}>
            PG-12
        </Badge>
        <Badge bg="secondary" style={{position:"absolute",zIndex:2,top:"8px",right:"10px",display:data.age_limit === 3 ? "block":"none"}}>
            R-15
        </Badge>
        <Badge bg="secondary" style={{position:"absolute",zIndex:2,top:"8px",right:"10px",display:data.age_limit === 4 ? "block":"none"}}>
            R-18
        </Badge>
        <Badge bg="secondary" style={{position:"absolute",zIndex:2,top:"8px",right:"10px",display:data.age_limit === 5 ? "block":"none"}}>
            R-18G
        </Badge>
        <Badge bg="secondary" style={{position:"absolute",zIndex:2,bottom:"8px",left:"10px",display:data.img_count > 1 ? "block":"none"}}>
            <Icon.CollectionFill /> {data.img_count}
        </Badge>
        <Badge bg="primary" style={{position:"absolute",zIndex:2,top:"8px",left:"10px",display:data.question_id && data.question_id.length > 0 ? "block":"none"}}>
            投票あり
        </Badge>
        {data.rank !== undefined ? (
        <div>
            <div className='text-center' style={{position:"absolute",backgroundColor:rankingBgColor(data.rank),opacity:rankingOpacity(data.rank),width:"40px",height:"40px",zIndex:"1",top:"10px",left:"10px",fontWeight:"bold",fontSize:"24px"}} />
            <div className='text-center' style={{position:"absolute",color:"#FFFFFF",width:"40px",height:"40px",zIndex:"1",top:"10px",left:"10px",fontWeight:"bold",fontSize:"24px"}}>
                {data.rank}
            </div>
        </div>
        ) : ""}
        <img data-no={i} loading="lazy" src={(data.limit_div !== "public" && data.plan_access === 0 || data.unit_amount > 0 && data.is_purchased === 0) ? (ApiFetch.API_PROTOCOL+'//'+(type === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST)+imgPath(type)+'/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT) : ApiFetch.API_PROTOCOL+'//'+(type === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST)+imgPath(type)+'/post/t/'+(data.id)+"_m"+ApiFetch.API_THUMB_EXT} style={{filter:(
            loginInfo.pg12_display_flag === 2 && data.age_limit === 2
            || loginInfo.r15_display_flag === 2 && data.age_limit === 3
            || loginInfo.r18_display_flag === 2 && data.age_limit === 4
            || loginInfo.r18g_display_flag === 2 && data.age_limit === 5
            ) || data.age_limit === 5 || data.sensitive_flag === 1 || data.sensitive_flag === 2 /*|| (data.limit_div !== "public" && data.plan_access === 0 || data.unit_amount > 0 && data.is_purchased === 0)*/ ? "blur(100px)" : "none",objectFit:"cover",width:"100%"}} className={"p-1 "+(from==="popup"?"lazy-popup":"lazy")+" tile-img-"+i}/>
        <div className={"p-0 "+from+"thumb-"+i} style={{opacity:0}}>
            <div style={{position:"absolute",zIndex:3,bottom:"60px",fontWeight:"bold",fontSize:"15px",whiteSpace:"nowrap",overflow:"hidden"}}>
                {/*<Link to={"/image/"+(data.group_id)} style={{color:"#FFFFFF",textDecoration:"none"}}>{data.title}</Link>*/}
                <span onClick={(e) => {
                    if(props.isLink){
                        navigate("/"+type+"/"+data.group_id)
                        return
                    }
                    if(props.onClick === undefined){
                        setShowViewPopup(true)
                    } else {
                        props.onClick()
                    }
                }} style={{color:"#FFFFFF",textDecoration:"none",cursor:"pointer"}}>{title}</span>
            </div>
            <div style={{position:"absolute",zIndex:3,bottom:"36px",whiteSpace:"nowrap",overflow:"hidden"}}>
                <Link to={"/user/"+(data.display_id !== undefined && data.display_id !== "" ? data.display_id : data.user_id)} style={{color:"#FFFFFF",fontWeight:"bold",textDecoration:"none",cursor:"pointer",display:"block"}}
                        onMouseOver={(e) => {
                            if(data.user_id !== "anonymous")
                            setInterval(() => {
                                getUserInfo(data.user_id).then(r => {
                                    let elm = document.getElementById("sub-"+random)
                                    if(elm){
                                        document.getElementById("sub-"+random).style.display = "block"
                                    }
                                    setDisplayId(r.display_id)
                                    setSelfIntroduction(r.self_introduction)
                                    setFollow(r.follow)
                                    setFollower(r.follower)
                                    setIsFollow(r.isFollow)
                                    clearAllInterval()
                                })
                            },500)
                        }}
                        onMouseLeave={() => {
                            clearAllInterval()
                        }}
                >
                    <Image loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/profile/'+(data.user_id)+'_s.jpg?'+data.hash} style={{borderRadius:"12px",display:data.user_id ? "inline" : "none"}} width="24px" height="24px" />
                    <ruby> {data.user_name && data.user_name.length > 8 ? data.user_name.substr(0,8) + "…" : data.user_name} <rp>(</rp><rt>{data.user_name_kana && data.user_name_kana.length > 8 ? data.user_name_kana.substr(0,8) + "…" : data.user_name_kana}</rt><rp>)</rp> </ruby>
                    <UserMark sms_auth={data.sms_auth} role={data.role} plan={data.plan} beginner={data.beginner} moderator_badge_display_flag={data.moderator_badge_display_flag} dialog={dialog} />
                    &nbsp;{data.isFollowed === 1 ? <span style={{fontSize:"12px",color:"#555555",backgroundColor:"#DDDDDD",borderRadius:"5px",padding:"2px"}}>フォローされています</span> : ""}
                </Link>
            </div>
            <FavoriteIcon style={{fontSize:"18px",cursor:"pointer",position:"absolute",zIndex:2,bottom:"8px",right:"10px",display:data.favorite !== undefined ? "inline" : "none"}} type={type} id={data.group_id} favorite={data.favorite} dialog={dialog} count={data.favorite_count} />
            {/*<Link to={"/image/"+(data.group_id)}><Container style={{position:"absolute",top:0,backgroundColor:"#000000",opacity:0.5,width:"100%",height:"100%",zIndex:2}}></Container></Link>*/}
            <div style={{position:"absolute",top:0,backgroundColor:"#000000",opacity:0.5,width:"100%",height:"100%",zIndex:1,cursor:"pointer"}}
                onClick={(e) => {
                    e.stopPropagation()
                    if(props.isLink){
                        navigate("/"+type+"/"+data.group_id)
                        return
                    }
                    if(props.onClick === undefined){
                        setShowViewPopup(true)
                    } else {
                        props.onClick()
                    }
                }}
            ></div>
            <Badge bg="secondary" style={{position:"absolute",bottom:"8px",left:"80px",zIndex:2,backgroundColor:"#FFFFFF",display:data.count !== undefined || data.pv_count !== undefined ? "block" : "none"}}>
                <Icon.EyeFill /> {data.count !== undefined ? data.count : data.pv_count}
            </Badge>
            {false && loginInfo.is_admin ? (
            <>
                <Form.Select className="mb-3" value={ageLimit} style={{position:"absolute",zIndex:1,top:"30px"}}
                    onChange={(e) => setAgeLimit(e.currentTarget.value)}
                >
                    <option value="年齢制限" disabled>【年齢制限】</option>
                    <option value="allAges">全年齢(性表現なし)</option>
                    <option value="r15">全年齢(R-15)</option>
                    <option value="r18">R-18</option>
                    <option value="r18g">R-18G</option>
                </Form.Select>
                <Button style={{position:"absolute",zIndex:1,top:"70px"}}
                    onClick={() => {
                        updateAgeLimitByAdmin(data.group_id,ageLimit).then(r => {
                            if(r.result){
                                dialog("確認","年齢制限を「"+r.data.ageLimitReturn+"」に更新しました。")
                            } else {
                                dialog("エラー",r.errors)
                            }
                        })
                    }}
                >更新(管理者権限)</Button>
            </>
            ) : ""}
        </div>
    </div>
    <UserInfoPopup data={data} displayId={displayId} selfIntroduction={selfIntroduction} isFollow={isFollow} follow={follow} follower={follower} random={random} dialog={dialog} />
</div>
    )
}
export default Tile